import loadable from '@loadable/component';

export const CmsFormBuilderBlockLoadable = loadable(
  () => import('./CmsFormBuilderBlock'),
  { resolveComponent: (module) => module.CmsFormBuilderBlock },
);
